/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Modules which admit settings
 */
export enum EnumStammdatenSettingModuleName {
    /**
     * No module
     */
    NotDefined = 0,
    /**
     * Settings relating to the address module
     */
    Addresses = 1,
}
